;(function module() {
  angular
    .module('app.ui.form.ctrls')
    .controller('DeleteAgGridFiltersController', [
      'filter',
      'type',
      '$uibModalInstance',
      'logger',
      'GridApi',
      function controller(filter, type, $uibModalInstance, logger, GridApi) {
        var vm = this
        vm.filter = filter
        vm.type = type

        vm.cancel = () => {
          $uibModalInstance.dismiss('cancel')
        }

        vm.confirmDelete = () => {
          if (vm.filter.isPublic) {
            if (vm.confirmationInput === 'DELETE') vm.removeSavedFilter(filter)
            else return logger.notify('warning', 'Wrong confirmation text')
          } else vm.removeSavedFilter(vm.filter)
        }

        vm.removeSavedFilter = filter => {
          const onDeleteSuccess = () => {
            logger.notify(
              'success',
              `Saved View '${filter.name}' has been deleted.`
            )
            $uibModalInstance.close(filter)
          }

          const onDeleteFailure = errorResponse => {
            logger.notify(
              'error',
              `Saved View '${filter.name}' could NOT be deleted. <br/> Error Reason: ${errorResponse.statusText}`
            )
          }

          GridApi.deleteGridFilterById(vm.filter.id)
            .then(onDeleteSuccess)
            .catch(onDeleteFailure)
        }
      },
    ])
})()



// WEBPACK FOOTER //
// ./scripts/shared/directives/ag-grid-listing/ag-grid-filters/delete-filters/delete-filters.ctrl.js